export const quickJournalCyberpunkTheme = {
    id: "cyberpunk",
    label: "Cyberpunk 2077",
    containerClassName: "QuickJournalContainerCyberpunkV1",
    overlay: {
        backgroundColor: "rgb(5, 6, 18)",
        backgroundImage:
            `linear-gradient(to bottom, rgba(5, 6, 18, 0.05) 0%, rgba(2, 3, 12, 0.72) 76%, rgb(0, 0, 0) 100%), ` +
            `linear-gradient(to bottom, rgba(19, 34, 76, 0.34) 0%, rgba(28, 9, 57, 0.14) 30%, rgba(3, 4, 16, 0) 62%), ` +
            `radial-gradient(circle at 18% 16%, rgba(0, 235, 255, 0.18), transparent 23%), ` +
            `radial-gradient(circle at 82% 13%, rgba(255, 29, 178, 0.16), transparent 25%), ` +
            `radial-gradient(circle at 54% 38%, rgba(87, 48, 184, 0.12), transparent 34%)`,
    },
    backdrop: {
        backgroundColor: "rgb(2, 3, 10)",
        topIos: "calc(100% - 12px)",
        topDefault: "calc(100% - 7px)",
        width: "max(640px, 100vw)",
        height: "280px",
        minHeight: "280px",
        maxHeight: "280px",
        background: `
            radial-gradient(
                ellipse 220px 92px at 50% 0px,
                rgba(74, 110, 190, 0.22) 0%,
                rgba(53, 64, 142, 0.14) 32%,
                rgba(29, 20, 78, 0.08) 58%,
                rgba(0, 0, 0, 0) 100%
            ),
            linear-gradient(
                112deg,
                rgba(218, 8, 131, 0.11) 0%,
                rgba(90, 14, 100, 0.05) 29%,
                rgba(0, 0, 0, 0) 55%
            ),
            linear-gradient(
                248deg,
                rgba(0, 187, 222, 0.12) 0%,
                rgba(0, 70, 118, 0.05) 31%,
                rgba(0, 0, 0, 0) 57%
            ),
            linear-gradient(
                8deg,
                rgba(188, 96, 35, 0.065) 0%,
                rgba(0, 0, 0, 0) 37%
            ),
            linear-gradient(
                to bottom,
                rgb(8, 20, 38) 0%,
                rgb(9, 11, 30) 42%,
                rgb(2, 3, 11) 78%,
                rgb(0, 0, 0) 100%
            )`,
        boxShadow:
            "inset 0 1px rgba(0, 225, 255, 0.11), inset 0 12px 36px rgba(0, 116, 184, 0.045), inset 0 -48px 120px rgba(0, 0, 0, 0.76)",
    },
    recentEntry: {
        color: "rgba(240, 217, 255, 0.96)",
        textShadow: "0 0 10px rgba(210, 80, 255, 0.16)",
        timestampColor: "rgba(194, 150, 218, 0.82)",
    },
    input: {
        color: "#8ff7ff",
        textShadow: "0 0 2px rgba(200, 255, 255, 0.95), 0 0 6px rgba(0, 235, 255, 0.8), 0 0 14px rgba(0, 210, 245, 0.5), 0 0 22px rgba(0, 190, 235, 0.24)",
        cursorLow: "#087c9b",
        cursorMid: "#12deeb",
        cursorHigh: "#ff43c4",
    },
    heatmap: {
        containerColor: "rgba(218, 253, 255, 0.94)",
        cellBackground: (level: number) => {
            if (level <= 0) return "rgba(102, 218, 236, 0.055)";
            if (level >= 4) return "rgba(255, 93, 205, 0.98)";
            if (level === 3) return "rgba(255, 36, 177, 0.88)";
            if (level === 2) return "rgba(0, 211, 229, 0.82)";
            return "rgba(0, 125, 165, 0.66)";
        },
        cellBoxShadow: "0 0 8px rgba(0, 219, 239, 0.12)",
        flashBoxShadow: "0 0 12px rgba(226, 255, 255, 0.96)",
        hoverOutline: "1px solid rgba(118, 247, 255, 0.98)",
        inactiveOpacity: 0.34,
        activeOpacity: 1,
    },
    toggle: {
        color: "#5feeff",
        opacity: 0.86,
        shadow: "drop-shadow(0px 0px 6px rgba(0, 196, 255, 0.58))",
        transform: "rotate(-135deg)",
    },
    switcher: {
        border: "rgba(0, 225, 255, 0.28)",
        background: "rgba(7, 10, 31, 0.62)",
        text: "rgba(186, 239, 247, 0.9)",
        activeBackground: "rgba(255, 30, 178, 0.2)",
        activeText: "rgba(235, 255, 255, 0.99)",
        activeBorder: "rgba(0, 239, 255, 0.72)",
    },
} as const;
